(() => {
  const consentBoolean = value => value === true || value === 'yes' || value === 'true';

  const initPreferences = root => {
    root.querySelectorAll('[data-cookie-preference-form]').forEach(form => {
      if (form.dataset.preferenceReady === 'true') return;
      form.dataset.preferenceReady = 'true';
      const message = form.querySelector('[data-cookie-message]');
      const toggles = Object.fromEntries(
        [...form.querySelectorAll('[data-cookie-purpose]')].map(input => [input.dataset.cookiePurpose, input])
      );

      const setMessage = (text, failed = false) => {
        if (!message) return;
        message.textContent = text;
        message.classList.toggle('is-error', failed);
      };

      const sync = api => {
        const current = api.currentVisitorConsent?.() || {};
        Object.entries(toggles).forEach(([purpose, input]) => {
          input.checked = consentBoolean(current[purpose]);
        });
      };

      const save = choices => {
        const api = window.Shopify?.customerPrivacy;
        if (!api?.setTrackingConsent) {
          setMessage(form.dataset.error, true);
          return;
        }
        api.setTrackingConsent(choices, result => {
          if (result?.error) setMessage(form.dataset.error, true);
          else {
            sync(api);
            setMessage(form.dataset.success);
          }
        });
      };

      form.addEventListener('submit', event => {
        event.preventDefault();
        save({
          preferences: Boolean(toggles.preferences?.checked),
          analytics: Boolean(toggles.analytics?.checked),
          marketing: Boolean(toggles.marketing?.checked)
        });
      });

      form.querySelector('[data-cookie-reject]')?.addEventListener('click', () => {
        Object.values(toggles).forEach(input => { input.checked = false; });
        save({ preferences: false, analytics: false, marketing: false });
      });

      const load = () => {
        if (window.Shopify?.customerPrivacy) {
          sync(window.Shopify.customerPrivacy);
          return;
        }
        if (!window.Shopify?.loadFeatures) {
          setMessage(form.dataset.error, true);
          return;
        }
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
          if (error || !window.Shopify?.customerPrivacy) setMessage(form.dataset.error, true);
          else sync(window.Shopify.customerPrivacy);
        });
      };
      load();
    });
  };

  const init = root => {
    if (!root || root.dataset.legalReady === 'true') return;
    root.dataset.legalReady = 'true';
    initPreferences(root);

    const links = [...root.querySelectorAll('.legal-toc a[href^="#"]')];
    const sections = links.map(link => root.querySelector(link.getAttribute('href'))).filter(Boolean);
    if (!('IntersectionObserver' in window) || !links.length || !sections.length) return;
    const observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      links.forEach(link => link.classList.toggle('active', link.getAttribute('href') === `#${visible.target.id}`));
    }, { rootMargin: '-25% 0px -65% 0px', threshold: [0, .2, .5] });
    sections.forEach(section => observer.observe(section));
  };

  const initAll = () => document.querySelectorAll('[data-legal-policy]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-legal-policy]')));
})();
